import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuid } from 'uuid';

import {
  FieldContextMenuEnabledOptions,
  FieldContextMenuFieldInfo,
  FieldContextMenuOperation,
  FieldContextMenuOption,
} from './field-context-menu';

@Component({
  selector: 'rl-field-context-menu',
  templateUrl: './field-context-menu.component.html',
  styleUrls: ['./field-context-menu.component.scss'],
})
export class FieldContextMenuComponent implements OnInit {
  @Input() field: FieldContextMenuFieldInfo;
  @Input() menuOptions: FieldContextMenuEnabledOptions = [];
  @Output() optionClicked = new EventEmitter<FieldContextMenuOperation>();

  private fieldId: string = uuid();

  buttonId = 'button-' + this.fieldId;
  ariaControlsId = 'dropdown-' + this.fieldId;

  fieldContextMenuOption = FieldContextMenuOption;

  // All enabled menu options, including the two defaults that
  // appear on every instance of the context menu
  allEnabledMenuOptions: FieldContextMenuEnabledOptions;

  ngOnInit(): void {
    this.allEnabledMenuOptions = [
      FieldContextMenuOption.REMOVE_FIELD,
      FieldContextMenuOption.MOVE_FIELD_TO_OTHER_PART,
      ...this.menuOptions,
    ];
  }

  get isRemoveFieldEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.REMOVE_FIELD,
    );
  }

  get isMoveFieldToOtherPartEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.MOVE_FIELD_TO_OTHER_PART,
    );
  }

  get isMoveIndexUpEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.MOVE_INDEX_UP,
    );
  }

  get isMoveIndexDownEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.MOVE_INDEX_DOWN,
    );
  }

  get isSwapAuthorPartsEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.SWAP_AUTHOR_PARTS,
    );
  }

  get isChangeAuthorToEditorEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.CHANGE_AUTHOR_TO_EDITOR,
    );
  }

  get isChangeEditorToAuthorEnabled(): boolean {
    return this.allEnabledMenuOptions.includes(
      FieldContextMenuOption.CHANGE_EDITOR_TO_AUTHOR,
    );
  }

  triggerMenuOption(fieldContextMenuEnum: FieldContextMenuOption): void {
    const payload: FieldContextMenuOperation = {
      ...this.field,
      operation: fieldContextMenuEnum,
    };

    this.optionClicked.emit(payload);
  }
}
